import { api } from "./api"

export const SEND_INVITE = async (formData : any) => {
    const {data} = await api.post("/companies/send/invite", formData)
    return data;
}

export const GET_COMPANY_INTEGRATION = async (key: string) => {
    const {data} = await api.get(`/companies/integrations/${key}`)
    return data;
}

export const SET_COMPANY_INTEGRATION = async (key: string, params: any, generates: {key: string}[] = []) => {
    const {data} = await api.post(`/companies/integrations/${key}`, {...params, generates})
    return data;
}

export const GET_ALL_INVITES = async () => {
    const {data} = await api.get("/companies/invites")
    return data.invites || [];
}

export const UPDATE_SELF_COMPANY = async (params) => {
    const {data} = await api.patch("/companies/self", params)
    return data;
}

export const GET_ALL_COMPANIES = async () => {
    const {data} = await api.get(`/companies/all`)
    return data;
}

export const CREATE_CHILDREN = async (params) => {
    const {data} = await api.post(`/companies/children`, params)
    return data;
}
